export default __webpack_public_path__ + "static/media/sum.3223816c.svg";